import { render, staticRenderFns } from "./ResultsMobile.vue?vue&type=template&id=5ee27af6&scoped=true&"
import script from "./ResultsMobile.vue?vue&type=script&lang=js&"
export * from "./ResultsMobile.vue?vue&type=script&lang=js&"
import style0 from "./ResultsMobile.vue?vue&type=style&index=0&id=5ee27af6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee27af6",
  null
  
)

export default component.exports